module.exports = __webpack_public_path__ + "static/img/index-carousel-04-02.ff1930c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-carousel-04-02.png
// module id = XOa8
// module chunks = 0